module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "popover",
    staticClass: "popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show"
  }, [_c('div', {
    staticClass: "popover-title"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_1_2'][1]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "popover-content"
  }, [_c('div', {
    staticClass: "form-group row mb-0"
  }, [_c('label', {
    staticClass: "col-4 col-form-label px-2"
  }, [_c('small', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_1_2'][2]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.input.event_key),
      expression: "input.event_key",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control transparent-input",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "123abc",
      "autocapitalize": "off"
    },
    domProps: {
      "value": (_vm.input.event_key)
    },
    on: {
      "change": function($event) {
        _vm.$v.input.event_key.$touch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.input.event_key = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "col-12 my-0 form-control-feedback"
  }, [_c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.event_key,
      "type": "required"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_1'][5]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.event_key,
      "type": "alphaNum"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_1'][6]"
    }
  })], 1), _vm._v(" "), _c('input-feedback', {
    attrs: {
      "validate-for-input": _vm.$v.input.event_key,
      "type": "stringLength"
    }
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "error['5_1'][7]"
    }
  })], 1), _vm._v(" "), (_vm.apiErrorI18nKey) ? _c('span', {
    staticClass: "form-control-feedback"
  }, [_c('i', {
    staticClass: "fa fa-asterisk",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": _vm.apiErrorI18nKey
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.tryForm
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_1_2'][3]"
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 form-hr"
  }, [_c('hr', {})])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-412f13b5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover/AddEventKeyPopover.vue
// module id = 695
// module chunks = 0